const SyncroUsersMappings = () => import('@/views/account/integrations/syncro/mappings/syncro-users-mappings-view.vue');
const SyncroOpportunitiesMappings = () => import('@/views/account/integrations/syncro/mappings/syncro-opportunities-mappings-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/Syncro/Manage/Users/Mappings',
        name: 'SyncroUsersMappings',
        component: SyncroUsersMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Syncro/Manage/Users/Mappings',
        name: 'ClientSyncroUsersMappings',
        component: SyncroUsersMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/Syncro/Manage/Opportunities/Mappings',
        name: 'SyncroOpportunitiesMappings',
        component: SyncroOpportunitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/Syncro/Manage/Opportunities/Mappings',
        name: 'ClientSyncroOpportunitiesMappings',
        component: SyncroOpportunitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    }
]